import React from 'react';
import List from '../components/list';
import Services from '../components/services';
import bannerImage from '../images/shutterstock_1030638148.jpg';
import balanceLogo from '../images/balance_logo.svg';
import Banner from '../components/banner';

const BusinessValuation = props =>
  (<main>
    <Banner
      title="Unternehmensbewertung"
      image={bannerImage}
    />
    <List
      text={
        <div>
          <ul>
            <li>Gutachten zur Bewertung von Unternehmen, Unternehmensteilen oder Gesellschaftsanteilen nach anerkannten Unternehmens&shy;bewertungs&shy;verfahren (z.B. Institut der Wirtschaftsprüfer IDW S1)</li>
            <li>Beratung und Begeleitung beim Kauf oder Verkauf von Unternehmen, Unternehmensteilen oder Gesellschaftsanteilen</li>
            <li>Bewertung für Zwecke der Erbschaft- oder Schenkungsteuer nach dem Vereinfachten Ertragswertverfahren gem. §&nbsp;199 Bewertungsgesetz</li>
          </ul>
          <br />
          <p>Für weitergehende Fragen können Sie uns gerne ansprechen.</p>
        </div>
      }
      icon={balanceLogo}
    />
    <Services
      taxAdvice={true}
      businessAdvice={true}
      servicesInCooperation={true}
      accounting={true}
      businessValuation={false}
    />
  </main>);

export default BusinessValuation;



// WEBPACK FOOTER //
// ./src/pages/unternehmensbewertung.js